<template>
  <div class="section__container">
    <div class="table__container">
      <div class="custom__table">
        <div class="custom__table-item active">
          <span class="table__item-title">
            Valor total de la inversión
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.TotalnvestmentValue) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Precio del activo subyancente
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.UnderlyingAssetPrice) }}</span>
            <span class="badge-stats success">{{ this.financialData.UnderlyingAssetPricePerc }} % </span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Costos de cierre
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.ClosingCosts) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Cuota de estructura
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.UpfrontDaoLLC) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Reserva inicial de mantenimiento ({{this.financialData.InitialMaintenanceReservePerc}}%)
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.InitialMaintenanceReserve) }}</span> 
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Comisión de Kraud por listado  ({{ this.financialData.KRAUDlistingFeePerc }}%)
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.KRAUDlistingFee) }}</span>
          </div>
        </div>
      </div>
      <div class="custom__table">
        <div class="custom__table-item active">
          <span class="table__item-title">
            Tasa Interna de Retorno
          </span>
          <div class="table__item-value">
            <span>{{ returnFormatNumber(this.financialData.TotalReturn) }} %</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Plusvalía proyectada
          </span>
          <div class="table__item-value">
            <span>{{ returnFormatNumber(this.financialData.ProjectedAppreciation) }} %</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Retorno anual
          </span>
          <div class="table__item-value">
            <span>{{ returnFormatNumber(this.financialData.CashReturn) }} %</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Cap Rate
          </span>
          <div class="table__item-value">
            <span>{{ returnFormatNumber(this.financialData.CapRate) }} %</span>
          </div>
        </div>
      </div>
      <div class="custom__table">
        <div class="custom__table-item active">
          <span class="table__item-title">
            Rentas brutas anuales
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.AnnualGrossRents) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Impuesto predial
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.PropertyTaxes) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Seguro
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.HomeownersInsurance) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Mantenimiento/Agua/Drenaje
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.HomeownersInsurance) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Administración de la propiedad
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.PropertyManagement) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Cuotas de administración
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.AnnualDAO) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Flujo de efectivo anual
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(this.financialData.AnnualCashFlow) }}</span>
          </div>
        </div>
        <div class="custom__table-item">
          <span class="table__item-title">
            Flujo de efectivo mensual
          </span>
          <div class="table__item-value">
            <span>${{ returnFormatNumber(financialData.MonthlyCashFlow) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-5">
      <div class="row">
        <div class="col-xl-4 col-lg-3 col-md-3 col-sm-2 col-2 text-left p-0  mr-2">
          <div class="container">
            <div class="row">
              <div class="col table__investment_title">
                
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_title">
                Flujo de efectivo neto acumulado
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_title">
                Plusvalía acumulada
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_title">
                Tu inversión
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_title">
                Valor total de la inversión
              </div>
            </div>
          </div>
        </div>
        <div class="text-center p-0 col-2">
          <div class="container table__investment_column1">
            <div class="row title-last-table">
              <div class="col table__investment_title pt-3 text-center">
                Año 5
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.CumulativeNetCashFlow5year }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.CumulativeAppreciationGain5years }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.YourInvestment5years }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ totalInvestmentValue5 }}
              </div>
            </div>
          </div>
        </div>
        <div class="text-center  p-0 col-2">
          <div class="container table__investment_column2">
            <div class="row">
              <div class="col table__investment_title pt-3 text-center">
                Año 10
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.CumulativeNetCashFlow10year }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.CumulativeAppreciationGain10years }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.YourInvestment10years }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ totalInvestmentValue10 }}
              </div>
            </div>
          </div>
        </div>
        <div class="text-center p-0 col-2">
          <div class="container table__investment_column3">
            <div class="row title-last-table">
              <div class="col table__investment_title pt-3 text-center">
                Año 20
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.CumulativeNetCashFlow20year }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.CumulativeAppreciationGain20years }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.YourInvestment20years }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ totalInvestmentValue20 }}
              </div>
            </div>
          </div>
        </div>
        <div class="text-center p-0 col-1">
          <div class="container table__investment_column4">
            <div class="row">
              <div class="col table__investment_title pt-3 text-center">
                Año 30
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.CumulativeNetCashFlow30year }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.CumulativeAppreciationGain30years }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ financialData.YourInvestment30years }}
              </div>
            </div>
            <div class="row">
              <div class="col table__investment_content">
                ${{ totalInvestmentValue30 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--h2 class="title__background">
      Projected returns per token
    </h2>
    <div class="selector__wrapper">
      <select>
        <option></option>
      </select>
    </div-->
  </div>
</template>
<script>
import numeral from 'numeral'
export default {
  name: 'FinancialsTab',
  props: {
    property: {
      type: Object,
      required: true
    }
  },
  data (){
    return {
      totalInvestmentValue5: 0,
      totalInvestmentValue10: 0,
      totalInvestmentValue20: 0,
      totalInvestmentValue30: 0,
      financialData: {}
    }
  },
  created () {
    console.log('ESto paso en la property FINANCIALS', this.property.attributes.property_financial.data)
    this.financialData = this.property.attributes.property_financial.data.attributes
    this.totalInvestmentValue5 = this.financialData.CumulativeNetCashFlow5year + this.financialData.CumulativeAppreciationGain5years + this.financialData.YourInvestment5years
    this.totalInvestmentValue10 = this.financialData.CumulativeNetCashFlow10year + this.financialData.CumulativeAppreciationGain10years + this.financialData.YourInvestment10years
    this.totalInvestmentValue20 = this.financialData.CumulativeNetCashFlow20year + this.financialData.CumulativeAppreciationGain20years + this.financialData.YourInvestment20years
    this.totalInvestmentValue30 = this.financialData.CumulativeNetCashFlow30year + this.financialData.CumulativeAppreciationGain30years + this.financialData.YourInvestment30years

  },
  methods: {
    returnFormatNumber(value) {
      return numeral(value).format("0,0.0")
    }
  }

}
</script>
<style lang="scss">
.table__investment_title {
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 600;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color:#0D051A;
  height: 48px;
  padding: 0px 5px;
}

.table__investment_content {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color:#0D051A;
  padding: 0px 5px;
  height: 48px;
}

.table__investment_column1 {
  width: 90px;
  background: linear-gradient(180deg, rgba(154, 238, 197, 0.3) 0%, rgba(154, 238, 197, 0) 100%);
}

.table__investment_column2 {
  width: 100px;
  background: linear-gradient(180deg, rgba(154, 198, 238, 0.3) 0%, rgba(155, 199, 238, 0) 100%);
}

.table__investment_column3 {
  width: 100px;
  background: linear-gradient(180deg, rgba(154, 162, 238, 0.3) 0%, rgba(154, 162, 238, 0.0078125) 97.4%, rgba(154, 238, 197, 0) 100%);
}

.table__investment_column4 {
  width: 100px;
  background: linear-gradient(180deg, rgba(201, 154, 238, 0.3) 0%, rgba(201, 154, 238, 0) 100%);
}

.section__container {
  display: flex;
  flex-direction: column;
  gap: 44px;
}

.title {
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  color: #351467;
  margin-bottom: 24px;
}

.table__container {
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.title__background {
  margin: 16px 0;
  padding: 14px 16px;
  background-color: #CAEEDD;
  font-weight: 600;
  color: #351467;
}
</style>